import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { dispatch } from 'store';
import { getCommonSearchData } from 'store/slices/commonSearch';

// material-ui
import { useTheme, styled } from '@mui/material/styles';
import { Box, InputAdornment, OutlinedInput, Select, MenuItem, FormControl, Button } from '@mui/material';

// project imports
import { capitalizeString } from 'helpers/stringFunctions';
import { devConsolelog } from 'helpers/utilityFunctions';

// assets
import { IconSearch, IconX } from '@tabler/icons';
import { shouldForwardProp } from '@mui/system';

const OutlineInputStyle = styled(OutlinedInput, { shouldForwardProp })(({ theme }) => ({
    width: 300,
    padding: '12px 16px',
    '& input': {
        padding: '0px !important'
    },
    [theme.breakpoints.down('md')]: {
        width: '50%',
        marginLeft: 4
    }
}));

const SelectStyle = styled(Select, { shouldForwardProp })(({ theme }) => ({
    width: 200,
    height: '44.13px',
    padding: '0px !important',

    [theme.breakpoints.down('md')]: {
        width: '100%',
        marginLeft: 4
    }
}));

const searchCategories = [
    {
        id: 'bookings'
    },
    {
        id: 'members'
    },
    {
        id: 'requirements'
    }
];

const CommonSearch = () => {
    const theme = useTheme();
    const [searchType, setSearchType] = useState('bookings');
    const [search, setSearch] = useState('');
    const navigate = useNavigate();

    const handleSearchType = (e) => {
        devConsolelog('selected searchtype', e.target.value);
        setSearchType(e.target.value);
    };

    const clearSearch = () => {
        setSearch('');
        dispatch(getCommonSearchData('', false));
    };

    const handleSearch = (key = '') => {
        devConsolelog('header searchvalue', key, search);
        if (search) {
            dispatch(getCommonSearchData(searchType, true, { [key]: { [search]: { id: search } } }));
            if (searchType === 'bookings') {
                navigate('/booking-list');
            } else if (searchType === 'members') {
                navigate('/member-list');
            } else if (searchType === 'requirements') {
                navigate('/requirement-funnel');
            }
        }
    };

    const handleEnter = (e) => {
        devConsolelog('handleEnter', e, e.key, e.keyCode);
        if (e.key && e.key === 'Enter') {
            handleSearch('search');
        } else if (e.keyCode && e.keyCode === 0) {
            handleSearch('search');
        }
    };

    return (
        <>
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', pl: 4, gap: '16px' }}>
                <FormControl>
                    <SelectStyle id="columnId" name="columnId" defaultValue="bookings" onChange={handleSearchType}>
                        {searchCategories.map((column) => (
                            <MenuItem key={`index_${column.id}`} value={column.id}>
                                {capitalizeString(column.id, ' ')}
                            </MenuItem>
                        ))}
                    </SelectStyle>
                </FormControl>
                <OutlineInputStyle
                    id="input-search-header"
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    placeholder="Search"
                    onKeyPress={handleEnter}
                    startAdornment={
                        <InputAdornment position="start">
                            <IconSearch stroke={1.5} size="16px" color={theme.palette.grey[500]} />
                        </InputAdornment>
                    }
                    endAdornment={
                        search && (
                            <InputAdornment position="start">
                                <IconX stroke={1.5} size="16px" color={theme.palette.grey[500]} cursor="pointer" onClick={clearSearch} />
                            </InputAdornment>
                        )
                    }
                    aria-describedby="search-helper-text"
                    inputProps={{ 'aria-label': 'weight' }}
                />
                <Button disabled={!search} variant="contained" size="large" onClick={() => handleSearch('search')}>
                    Search
                </Button>
            </Box>
        </>
    );
};

export default CommonSearch;
